/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'

/**
 * Import
 * - Actions
 */
import {
    fetchLocations,
    fetchCountries,
    addLocations,
    addLocationsRenewals,
    addLocationsSecurity,
    deleteLocation,
    submitStep02,
    resetQuotes,
    findLatLong,
    getRenewalVariation,
    fetchOccupancies,
} from '../../../actions'
import { get } from 'lodash'

/**
 * Import
 * - Page component
 */
import Step02cp from '../../../components/pages/Quote/Step02cp/Step02cp'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        quote: 'The QUOTE! Step02',
        riskLocations: state.quote.riskLocations,
        countries: state.step00.countries,
        checkStep: state.quote.checkStep,
        occupancies: get(state, 'step00.occupancies.data', []),
    }
}

export default connect(mapStateToProps, {
    fetchLocations,
    fetchCountries,
    addLocations,
    addLocationsRenewals,
    addLocationsSecurity,
    deleteLocation,
    submitStep02,
    resetQuotes,
    getLatLong: findLatLong,
    getRenewalVariation,
    fetchOccupancies,
})(Step02cp)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Quote/Step02cp.tsx